<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('customers', {status: form.status})">Customers</inertia-link>
      <span class="text-indigo-400 font-medium">/ Update</span>

    </h1>
    <trashed-message v-if="customer.deleted_at" class="mb-6" @restore="restore">
      This customer has been deleted.
    </trashed-message>
    <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-3">
      <div>
          <form @submit.prevent="submit" class="bg-white rounded shadow overflow-hidden block">

            <div class="w-full text-right p-2">
              <p class="text-xs">Account created on {{ customer.created_at | localDateTime }}</p>
            </div>

              <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                  <div class="pr-6 pb-8 w-full" v-if="!form.personal_account">
                      <div class="text-sm">
                          <input type="checkbox" v-model="form.none_tax" class="form-check input" :disabled="!editable">
                          Not tax-registered
                      </div>
                  </div>
                  <div v-if="form.personal_account">
                    <h3>Personal Account</h3>
                  </div>

                  <div class="pr-6 pb-8 w-full">
                      <div class="text-sm" v-if="customer.credit_customer">
                          <span class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium leading-5 bg-pink-100 text-pink-800">CREDIT CUSTOMER</span>
                      </div>
                  </div>


                <div class="w-full  lg:w-1/2 pr-6 pb-8">
                  <select-input v-model="form.personal_account" :disabled="!editable" :errors="$page.props.errors.personal_account" class="w-full" label="Account Type">
                    <option :value="null" />
                    <option :value="0">Business</option>
                    <option :value="1">Personal</option>
                  </select-input>
                </div>

                  <text-input :disabled="!editable" v-model="form.name" :errors="$page.props.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Customer Account Name" />
                  <text-input v-if="!form.personal_account" v-model="form.tin_number" :disabled="!editable || form.none_tax" :errors="$page.props.errors.tin_number" class="pr-6 pb-8 w-full lg:w-1/2" label="TIN Number" />

                  <text-input v-if="!form.personal_account" :disabled="!editable" v-model="form.ls_number" :errors="$page.props.errors.ls_number" class="pr-6 pb-8 w-full lg:w-1/2" label="LS Number" />

                <select-input v-model="form.price_group" :errors="$page.props.errors.price_group" class="pr-6 pb-8 w-full lg:w-1/2" label="Price Group">
                  <option disabled></option>
                  <option v-for="(price_group, pg_index) in price_groups" :value="pg_index">{{ price_group }}</option>
                </select-input>

                <select-input v-if="!form.personal_account" :disabled="!editable" v-model="form.business_type" :errors="$page.props.errors.business_type" class="pr-6 pb-8 w-full lg:w-1/2" label="Business Type">
                      <option :value="null" />
                      <option v-for="(btype, bkey) in business_types" :value="bkey" :key="bkey">{{ btype }}</option>
                  </select-input>

                  <select-input :disabled="!editable" v-model="form.atoll_id" :errors="$page.props.errors.atoll_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Atoll">
                      <option :value="null" />
                      <option v-for="atoll in atoll_list" :value="atoll.id" :key="atoll.id">{{ atoll.name }}</option>
                  </select-input>

                  <select-input :disabled="!editable" v-model="form.island_id" :errors="$page.props.errors.island_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Island" >
                      <option :value="null" />
                      <option v-if="form.atoll_id && form.atoll_id === irow.atoll_id" v-for="irow in island_list" :value="irow.id" :key="irow.id">{{ irow.name }}</option>
                  </select-input>

                <div class="w-full  lg:w-1/2 pr-6 pb-8">
                  <select-input v-model="form.credit_customer" :errors="$page.props.errors.credit_customer" class="w-full" label="Is Credit Customer">
                    <option :value="false">No</option>
                    <option :value="true">Yes</option>
                  </select-input>
                </div>

                  <div class="w-full  lg:w-1/2 pr-6 pb-8">
                      <select-input v-model="form.status" :errors="$page.props.errors.status" class="w-full" label="Status">
                          <option :value="null" />
                          <option v-for="(status, skey) in $page.props.statuses" :value="skey" :key="skey">{{ status }}</option>
                      </select-input>
                      <p v-if="customer.status === 'approved'" class="text-sm leading-normal">Approved by {{ customer.approved_by }}</p>
                  </div>

                <div class="pr-6 pb-8 w-full pr-6 pb-8">
                  <div class="flex items-center border border-gray-200 rounded p-4">
                    <toggle v-model="form.auto_approve_orders"></toggle>
                    <span class="ml-3 text-sm" v-if="form.auto_approve_orders">Auto approve orders from this customer? Yes</span>
                    <span class="ml-3 text-sm" v-else>Auto approve orders from this customer? No</span>
                  </div>
                </div>

                <div class="pr-6 pb-8 w-full pr-6 pb-8">
                  <div class="flex items-center border border-gray-200 rounded p-4">
                    <toggle v-model="form.special_customer"></toggle>
                    <span class="ml-3 text-sm" v-if="form.special_customer">Special Customer? Yes</span>
                    <span class="ml-3 text-sm" v-else>Special Customer? No</span>
                  </div>
                </div>

                  <div class="pr-6 pb-8 w-full pr-6 pb-8" v-if="canAdmin('bypass-on-customers')">
                      <div class="flex items-center border border-gray-200 rounded p-4">
                          <toggle v-model="form.bypass_daily_order_limit" label="Bypass daily order limit for this customer"></toggle>
                          <span class="ml-3 text-sm">Enable to allow customer to place order without daily order limit restriction just for today</span>
                      </div>
                  </div>
                  <div v-else-if="form.bypass_daily_order_limit">
                      <div class="flex items-center border border-gray-200 rounded p-4 bg-indigo-100">
                          <span class="ml-3 text-sm text-indigo-600">This customer is allowed to by pass the daily limit just for today.</span>
                      </div>
                  </div>

              </div>


              <div class="p-8 -mr-6 -mb-8" v-if="similar.length > 0">
                  <p class="text-lg font-bold">Found Similar Account</p>
                  <div class="grid grid-cols-3 gap-4">
                      <div class="my-2 border border-gray-200 mr-6 p-2 bg-gray-100 rounded" v-for="acct in similar">
                          <div class="text-sm leading-5 font-medium text-indigo-600 truncate">
                            <inertia-link :href="route('customers.edit', acct.id)">{{ acct.name }}</inertia-link>
                          </div>
                          <div class="text-sm leading-5 font-medium text-uppercase font-bold text-red-400" v-if="acct.credit_customer">CREDIT CUSTOMER</div>
                          <div class="text-sm leading-5 font-medium text-gray-500">Location : {{ acct.location }}</div>
                          <div class="text-sm leading-5 font-medium text-gray-500" v-if="acct.atoll">{{ acct.atoll.code }}. {{ acct.island.name }}</div>

                          <div class="mt-2 text-sm leading-5 text-gray-500">
                              <label class="mr-2">TIN</label>
                              <div class="truncate">{{ acct.tin_number }}</div>
                          </div>

                          <div class="mt-2 text-sm leading-5 text-gray-500">
                              <label class="mr-2">Business Type</label>
                              <div class="truncate">{{ business_types[acct.business_type] }}</div>
                          </div>

                          <div class="mt-2 text-sm leading-5 text-gray-500">
                              <label class="mr-2">LS Customer #</label>
                              <div class="truncate">{{ acct.ls_number }}</div>
                          </div>

                          <div class="mt-2 text-sm leading-5 text-gray-500">
                              <label class="mr-2">Status</label>
                              <div class="truncate lead font-bold">{{ acct.status }}</div>
                          </div>

                      </div>
                  </div>
              </div>
              <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
                  <button v-if="!customer.deleted_at && canAdmin('delete-customers')" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="showConfirmDeleteActionModal">Delete Customer</button>
                  <loading-button :loading="sending" class="btn-primary ml-auto" type="submit">Update Customer</loading-button>
              </div>
          </form>
      </div>
      <div class="mt-3 lg:mt-0">
        <div class="mb-3">
            <h2 class="font-bold text-md">Customer account users</h2>
            <customer-users :users="customer.users" class="mt-2" :customer-id="customer.id" @onShowUserModel="showUserViewModal"></customer-users>
        </div>

          <div class="mb-3">
              <h2 class="font-bold text-md">{{ orderLable }}</h2>
              <last-ten-orders :orders="orders" class="mt-2"></last-ten-orders>
          </div>
      </div>
    </div>
    <Modal :show="customerUserSelected !== null" @closeModal="closeUserViewModal">
      <UserLinkedAccounts :user="customerUserSelected"  />
    </Modal>
    <Modal :show="confirmDeleteAction" @closeModal="closeConfirmDeleteAction">
      <div>
        <h2>You are about to delete this customer account.</h2>
        <p>Please review and choose a relevant option</p>

        <label class="rounded m-2 border border-gray-300 flex flex-row">
          <input type="radio" v-model="deleteForm.option" value="move" class="mx-3" />
          <div class="p-2">
            <p class="text-sm text-black">Delete this account and move all the orders and users to another account</p>
            <div class="mt-3">
              <p class="text-sm leading-normal">Enter Customer Number (LS NUMBER)</p>
              <input type="text" v-model="deleteForm.ls_number" class="border border-gray-500 rounded p-2 w-56" @change="fetchMergingCustomer" />
            </div>
            <div v-if="deleteMergingCustomerDetails">
              <label for="name" class="text-sm py-2">Customer Details</label>
              <div class="border-t border-gray-500 my-2">
                <p class="text-sm text-gray-700" >{{ deleteMergingCustomerDetails.name }}</p>
                <p class="text-sm text-gray-700">{{ deleteMergingCustomerDetails.atoll.code }}. {{ deleteMergingCustomerDetails.island.name }}</p>
                <p class="text-sm text-gray-700" v-if="!deleteMergingCustomerDetails.none_tax">TIN {{ deleteMergingCustomerDetails.tin_number }}</p>
                <p class="text-sm text-gray-700" v-else>Tax unregistered</p>
              </div>
            </div>
          </div>
        </label>

        <label class="rounded m-2 border border-gray-300 flex flex-row">
          <input type="radio" v-model="deleteForm.option" value="unlink" :disabled="orders.length > 0" class="mx-3" />
          <div class="p-2">
            <p class="text-sm text-black">Delete this account and unlink users.</p>
            <p class="text-xs text-gray-500">This option not available when having orders under this account.</p>
          </div>
        </label>

        <button :disabled="!readyToDelete" class="btn btn-primary mt-4" @click="destroy">Proceed Action</button>


      </div>
    </Modal>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import DeliveryAddressCard from '@/Shared/DeliveryAddressCard'
import CustomerUsers from './CustomerUsers'
import LastTenOrders from './LastTenOrders'
import Toggle from '@/Shared/Toggle'
import Modal from '@/Shared/Modal'
import UserLinkedAccounts from './UserLinkedAccounts'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  layout: Layout,
  components: {
    Toggle,
    Modal,
    UserLinkedAccounts,
    CustomerUsers,
    DeliveryAddressCard,
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    DeliveryAddressCard,
    CustomerUsers,
    LastTenOrders
  },
  props: {
    customer: Object,
    statuses: Object,
    similar: Array,
    business_types: Object,
    locations: Object,
    atoll_list: Array,
    island_list: Array,
    orders: Array,
    price_groups: Array,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      editable: true,
      customerUserSelected: null,
      confirmDeleteAction: false,
      deleteMergingCustomerDetails: null,
      deleteForm: {
        option: null,
        ls_number: null,
      },
      form: {
        personal_account: this.customer.personal_account,
        auto_approve_orders: this.customer.auto_approve_orders,
        none_tax: this.customer.none_tax,
        price_group: this.customer.price_group,
        name: this.customer.name,
        ls_number: this.customer.ls_number,
        tin_number: this.customer.tin_number,
        location: this.customer.location,
        status: this.customer.status,
        special_customer: this.customer.special_customer,
        bypass_daily_order_limit: this.customer.bypass_daily_order_limit,
        business_type: this.customer.business_type,
        credit_customer: this.customer.credit_customer,
        atoll_id: this.customer.atoll_id,
        island_id: this.customer.island_id
      }
    }
  },

  computed: {

    orderLable: function () {
        if(this.orders.length > 10) {
          return 'Last 10 orders'
        } else {
          return 'Last orders'
        }
    },

    readyToDelete: function() {
      if(this.deleteForm.option) {
        if(this.deleteForm.option === 'move') {
          if(this.deleteForm.ls_number) {
            if(this.deleteMergingCustomerDetails) {
              return true
            }
          }
        } else {
          if(this.orders.length > 0) {
            return false
          }
          return true
        }
      }
      return false
    }
  },

  watch: {
    'form.none_tax': function(val) {
      if(val) {
        this.form.tin_number = null;
      }
    }
  },
  methods: {
    submit() {
      this.sending = true
      this.$inertia.put(this.route('customers.update', this.customer.id), this.form,{
        onFinish : () => this.sending = false
      })

      // if(this.form.status == 'approved' && this.customer.status != 'approved') {
      //   this.$inertia.put(this.route('customers.update-review', this.customer.id), this.form)
      //     .then(() => this.sending = false)
      // } else {
      //
      // }

    },

    fetchMergingCustomer() {
      if(this.deleteForm.ls_number) {
        this.$http.get(this.route('ajax.customer.with-lsNumber', this.deleteForm.ls_number))
        .then((response) => {
          this.deleteMergingCustomerDetails = response.data
        });
      } else {
        this.deleteMergingCustomerDetails = null;
      }
    },

    closeConfirmDeleteAction() {
      this.confirmDeleteAction = false;
    },

    showConfirmDeleteActionModal() {
      this.confirmDeleteAction = true;
    },

    destroy() {

      if(this.readyToDelete) {
        if(this.deleteForm.option === 'move') {
          this.$inertia.delete(this.route('customers.destroy', {customer: this.customer.id, option: 'move', ls_number: this.deleteForm.ls_number}))
        } else {
          this.$inertia.delete(this.route('customers.destroy', {customer: this.customer.id, option: 'unlink'}))
        }
      }
    },

    restore() {
      if (confirm('Are you sure you want to restore this customer?')) {
        this.$inertia.put(this.route('customers.restore', this.customer.id))
      }
    },

    showUserViewModal(user) {
      this.customerUserSelected = user;
    },

    closeUserViewModal() {
      this.customerUserSelected = null;
    },

    getIslandName(islandCode) {
      if(this.island_list.length) {
        let found = this.island_list.find(island => island.code == islandCode);

        if(found) {
          return found.island
        }
      }

      return null
    }
  },
}
</script>
